import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/admin/tickets/")({
  loader: () => {
    throw redirect({
      to: "/admin/tickets/bugreport",
    });
  },
});
